<!--
  --
  -- 個人情報設定 グループ
  --
  -->
<template>
  <c-form card-style
    v-model="valid"
    @submit="onSubmit"
  >
    <!-- Title -->
    <v-card-title>
      <slot name="title"/>
    </v-card-title>

    <!-- Contents -->
    <v-card-text>
      <slot/>

      <!-- 氏名 -->
      <c-profile-name :form="form"/>

      <!-- 性別 -->
      <c-profile-gender :form="form"/>

      <!-- 生年月日 -->
      <c-profile-birthday :form="form"/>

      <!-- 住所 -->
      <c-profile-address :form="form"/>

      <!-- 電話番号 -->
      <c-profile-phone :form="form"/>
    </v-card-text>

    <c-card-errors :errors="errors"/>

    <!-- Actions -->
    <v-card-actions>
      <v-spacer/>

      <!-- template v-if="demoMode">
        <v-btn
          text outlined
          @click="onClearData"
          v-text="'クリア'"
        />
        <v-btn
          text outlined
          @click="onFillTestData"
          v-text="'テスト'"
        />
      </template -->

      <v-btn
        color="primary" type="submit"
        :loading="running"
        :disabled="!valid || running"
      >
        <slot name="submit-text"/>
      </v-btn>
    </v-card-actions>
  </c-form>
</template>

<script>
import CForm from '@/components/CForm'
import CCardErrors from '@/components/CCardErrors'
import CProfileName from './CProfileName'
import CProfileGender from './CProfileGender'
import CProfileBirthday from './CProfileBirthday'
import CProfileAddress from './CProfileAddress'
import CProfilePhone from './CProfilePhone'

import deepmerge from 'deepmerge'
import * as C from '@/consts'

export default {
  name: 'CProfileGroup',
  components: {
    CForm,
    CCardErrors,
    CProfileName,
    CProfileGender,
    CProfileBirthday,
    CProfileAddress,
    CProfilePhone
  },
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // フォームデータ
    form: {
      familyName: '',
      givenName: '',
      familyKana: '',
      givenKana: '',
      gender: 0,
      birthday: '',
      postal: '',
      address1: '',
      address2: '',
      phone: ''
    },

    // デモデータ挿入する/しない
    demoMode: !!process.env.VUE_APP_DEMO_REGISTER,

    // フォームのバリデーション状態
    valid: true,

    // フォームのエラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),
  created () {
    // profile プロパティから form にデータをコピーする
    this.form = deepmerge(this.profile, {})
  },
  methods: {
    /**
     * Submit ボタンが押された
     */
    onSubmit () {
      // エラー表示を消す
      this.errors = []

      // フォーム入力されたことを通知する
      this.running = true
      this.$emit('submit', this.form, errors => {
        this.running = false
        if (errors) {
          this.errors = errors
        }
      })
    },

    onClearData () {
      // profile プロパティから form にデータをコピーする
      this.form = deepmerge(this.profile, {})
    },

    onFillTestData () {
      this.form.familyName = 'テスト'
      this.form.givenName = '花子'
      this.form.familyKana = 'てすと'
      this.form.givenKana = 'はなこ'
      this.form.gender = C.FEMALE
      this.form.birthday = '2000-04-01'
      this.form.postal = '150-0012'
      this.form.address1 = '東京都渋谷区広尾'
      this.form.address2 = '1丁目-2-3'
      this.form.phone = '090-1000-1000'
    }
  }
}
</script>
